import React from 'react';
import { Box, Typography } from '@mui/material';

const FormFieldBlock = ({ title, description, children }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
    <Box>
      <Typography component="div" sx={{ color: '#0f172a', fontWeight: 900, fontSize: '0.95rem', lineHeight: 1.45 }}>
        {title}
      </Typography>
      {description ? (
        <Typography component="div" variant="body2" sx={{ color: '#64748b', lineHeight: 1.65, mt: 0.35 }}>
          {description}
        </Typography>
      ) : null}
    </Box>
    {children}
  </Box>
);

export default FormFieldBlock;
